import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledChooseBrokerPage = styled.div`
    height: 100vh;
    overflow: auto;
    background-color: var(--color-grey-400);
`;

export const StyledTitle = styled.div`
    &.title {
        padding-bottom: 0;
        margin-top: 7.5rem;

        @media ${breakpoints.xxs} {
            display: none;
        }
    }
`;

export const StyledBrokersContainer = styled.div`
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-top: 8rem;

    display: grid;
    gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));

    @media ${breakpoints.sm} {
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    }

    @media ${breakpoints.xxs} {
        margin-top: 48px;
        grid-template-columns: repeat(1, 1fr);
    }
`;

export const StyledBrokerItem = styled.div`
    max-width: 220px;
    cursor: pointer;
    margin: 0 auto;
    @media ${breakpoints.sm} {
        max-width: 120px;
    }

    @media ${breakpoints.xxs} {
        width: inherit;
        max-width: inherit;
        margin: 0 16px;
        padding-top: 8px;
        padding-bottom: 8px;

        @media ${breakpoints.xxs} {
            background-color: var(--color-white);
            border-radius: var(--radius-5);
            box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
        }
    }
`;

export const StyledImageContainer = styled.div`
    display: flex;
    align-items: center;
    width: 21.8rem;
    height: 21.8rem;
    overflow: hidden;

    @media ${breakpoints.xxsMin} {
        background-color: var(--color-white);
        border-radius: var(--radius-10);
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    }
    @media ${breakpoints.sm} {
        width: 12rem;
        height: 12rem;
    }
    @media ${breakpoints.xxs} {
        width: 100px;
        height: 60px;
        margin: auto;
    }
`;

export const StyledImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    border-radius: inherit;
    padding: 15px;

    img {
        width: 100%;

        @media ${breakpoints.xxs} {
            max-width: 100px;
            max-height: 60px;
        }
    }
`;

export const StyledBrokerName = styled.div`
    margin-top: 16px;
    font-size: var(--size-20);
    font-weight: var(--weight-600);
    line-height: 22px;
    color: var(--color-primary);
    text-align: center;
    @media ${breakpoints.sm} {
        font-size: var(--size-16);
    }
`;

export const StyledEmptyContainer = styled.div`
    margin: 100px auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
    gap: 24px;

    box-sizing: border-box;
`;
